
import { defineComponent, computed, inject, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import RecipeStore from '@/store'
import Arrow from '@/components/UI/Icon/Arrow.vue'

import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Arrow
  },
  setup () {
    const { t } = useI18n()

    const store = inject('store', RecipeStore)
    const router = useRouter()

    const isStretch = ref(false)

    const getCategories = computed(() => {
      return store.getters.getCategory
    })

    function onStretch () {
      console.log('stretch')
      isStretch.value = !isStretch.value
    }

    function onCategoryMeals (category: string) {
      router.push({
        name: 'searchResult',
        query: { ca: category.toLowerCase() }
      })

      store.GET_MEALS_BY_CATEGORY(category)
    }

    onMounted(() => {
      isStretch.value = false
    })

    return {
      getCategories,
      onCategoryMeals,
      isStretch,
      onStretch,
      t
    }
  }
})
